import styled from "styled-components";

export const Container = styled.div<{ isDisabled: boolean }>(
  ({ isDisabled }) => ({
    position: "relative",

    ...(isDisabled ? { opacity: 0.5, pointerEvents: "none" } : {}),
  })
);

export const Dropdown = styled.div<{
  isDropdownVisible: boolean;
  className?: string;
}>(({ isDropdownVisible }) => ({
  display: isDropdownVisible ? "block" : "none",
  position: "absolute",
  bottom: -14,
  transform: "translateY(100%)",
  left: 0,
  width: "100%",
  backgroundColor: "#f6f6f6",
  zIndex: 15,
  boxShadow: "0px 4px 30px 5px rgba(0, 0, 0, 0.2)",
  border: "1px solid rgba(112,112,112,0.4)",
}));

export const Options = styled.div(({ theme }) => ({
  maxHeight: 204,
  overflow: "auto",
  backgroundColor: "#f6f6f6",
}));

export const Option = styled.button<{ isSelected: boolean }>(
  ({ theme, isSelected }) => ({
    display: "block",
    width: "100%",
    fontSize: 18,
    lineHeight: 1.25,
    textAlign: "left",
    padding: `14px 16px`,
    cursor: "pointer",
    backgroundColor: isSelected ? "var(--primary)" : "transparent",
    color: isSelected ? "#ffffff" : "#000000",

    ":hover": {
      backgroundColor: "var(--primary)",
      color: "white",
    },

    ":focus": {
      backgroundColor: "var(--primary)",
      color: "white",
    },
  })
);

export const StyledChevron = styled.div<{ rotated: boolean }>(
  ({ rotated }) => ({
    transition: "transform 0.4s ease",
    transform: `rotate(${rotated ? 180 : 0}deg)`,
    cursor: "pointer",
    color: "var(--arrow-color)",
  })
);

export const CloseButton = styled.button<{ $visible: boolean }>(
  ({ $visible }) => ({
    display: "flex",
    opacity: Number($visible),
    pointerEvents: $visible ? "all" : "none",
    transition: "opacity 0.15s, display 0.15s 0s",

    ...($visible
      ? {
          "&:hover, &:focus": {
            opacity: 0.7,
          },

          "&:active": {
            opacity: 0.5,
          },
        }
      : {}),
  })
);
